/** Spanish labels for the business category enum (services/api CATEGORY_VALUES). Unknown values fall back to the raw string. */
const CATEGORY_LABEL: Record<string, string> = {
  restaurant: 'Restaurante',
  barbershop: 'Barbería',
  salon: 'Salón',
  doctor: 'Doctor',
  florist: 'Florería',
  autoshop: 'Taller',
  gym: 'Gimnasio',
  nailstudio: 'Estudio de uñas',
  spa: 'Spa',
  classstudio: 'Estudio de clases',
  dogwalker: 'Paseador de perros',
  cleaner: 'Limpieza',
  plumber: 'Plomero',
  electrician: 'Electricista',
  handyman: 'Reparaciones',
  tutor: 'Tutor',
  trainingcenter: 'Centro de entrenamiento',
};

export function categoryLabel(category: string): string {
  return CATEGORY_LABEL[category] ?? category;
}
